import { useSessionQuery } from '../session/useSessionQuery.ts';
import type { UseSession } from './context/PermissionHookTypes.ts';

export const useSession: UseSession = () => {
  const { data, isPending } = useSessionQuery();

  return {
    isLoading: isPending,
    session: data.details,
  };
};
